<template>
  <div>
    <ul>
      <template v-if="mockGroups.length > 0 && type == 'all' ">
        <li
          v-for="(user, index) in mockGroups"
          :key="index"
          :class="{ 'suspended-bg': user.status !== '1' }"
        >
          <div class="grp-admin-info">
            <span class="email">{{ user.email }}</span>
            <span class="status-label" :class="user.status === '2' ? 'suspended' : 'active'">
              {{ user.status !== '1' ? 'Suspended' : 'Active' }}
            </span>
          </div>
          <div class="grp-admin-action">
            <custom-button
              v-if="showOtherBtns && type == 'all'"
              :key="user.id + '-' + user.status"
              :title="user.status !== '1' ? 'Activate' : 'Suspend'"
              :className="user.status !== '1' ? 'activate-btn' : 'suspend-btn'"
              :iconClass="user.status !== '1' ? 'fas fa-check' : 'fas fa-ban'"
              @onClicked="openStatusConfirm(user, index)"
            />
            <!-- Not Required For Now -->
            <!-- <custom-button
              v-if="showOtherBtns && user.status == '1'"
              title="Enable cc email"
              className="ccEmail"
              iconClass="far fa-envelope"
              @onClicked="openEmailModal(user.email)"
            /> -->
            <custom-button
              v-if="showOtherBtns"
              title="Delete"
              className="deleteEmail"
              iconClass="far fa-trash-alt"
              @onClicked="deleteUser(user.id, user.email)"
            />
          </div>
        </li>
      </template>
      <template v-else-if="type == 'pending'">
        <li>
          <p class="text-center">No {{ type }} admins found.</p>
        </li>
      </template>
      <template v-else>
        <li>
          <p class="text-center">No {{ type }} admins found.</p>
        </li>
      </template>
    </ul>
    <EnableEmailModal
      ref="emailModal"
      :email="selectedEmail"
      @onSubmit="handleEmailModalSubmit"
      @onCloseModal="handleEmailModalClose"
    />
  </div>
</template>

<script>
  import EnableEmailModal from '@/pages/GroupAdministrator/modal/EnableEmailModal.vue';
  import CustomButton from '@/components/ui/CustomButton.vue';
  import Api from "@/resource/Api";

  export default {
    components: {
      EnableEmailModal,
      CustomButton
    },
    data() {
      return {
        mockGroups: [],
        selectedUser: null,
        selectedIndex: null,
        showConfirmDialog: false,
        selectedEmail: "",
        showEmailModal: false,
      };
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      admins: {
        type: Array,
        default: () => [],
      },
      showOtherBtns: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      openStatusConfirm(user,index) {
        const action = user.status === '1' ? 'suspend' : 'activate';

        const dialogClass =
          action === 'activate' ? 'group-app-confirm-dialog' : 'group-app-warning-dialog';

        this.$store.commit('setDialogClass', dialogClass);

        this.$confirm({
          title: `${action.charAt(0).toUpperCase() + action.slice(1)} Admin`,
          message: `Do you want to ${action} this admin?`,
          button: {
            no: 'No',
            yes: 'Yes',
          },
          className: action === 'activate' ? 'activate-dialog' : 'suspend-dialog',
          callback: (confirm) => {
            if (confirm) {
              this.toggleStatus(index, user.status);
            }
          },
        });
      },
      toggleStatus(index, status) {
          const user = this.mockGroups[index];
          const newStatus = status === '1' ? '2' : '1';
          const data = {
            group_user_id: user.id,
            status: newStatus,
          };
          const loader = this.$loading.show();

          Api.post('activate-deactivate-group-user', data)
            .then((response) => {
              this.mockGroups[index].status = newStatus;
              this.$notify(response.data.message);
              this.$emit("onSuccess");
            })
            .catch((err) => {
              this.$notify(err.response.data.message, "error");
            })
            .finally(() => {
              loader.hide();
            });

      },
      cancelToggleStatus() {
        this.resetConfirmDialog();
      },
      resetConfirmDialog() {
        this.selectedUser = null;
        this.selectedIndex = null;
        this.showConfirmDialog = false;
      },
      openEmailModal(email) {
        this.selectedEmail = email;
        this.$refs.emailModal.showModal();
      },
      handleEmailModalSubmit(message) {
        this.$notify(message); 
        this.selectedEmail = "";
        this.$bvModal.hide("cc-email-modal");
      },
      handleEmailModalClose() {
        this.showEmailModal = false;
        this.selectedEmail = "";
        this.$bvModal.hide("cc-email-modal");
      },
      deleteUser(userId, userEmail) {
        this.$store.commit('setDialogClass', 'group-app-warning-dialog');

        this.$confirm({
          title: 'Delete Admin',
          message: `Are you sure you want to delete ${userEmail}?`,
          button: {
            no: 'Cancel',
            yes: 'Delete',
          },
          callback: (confirm) => {
            if (confirm) {
              const loader = this.$loading.show();
              Api.delete(`delete-group-user/${userId}`)
              .then(() => {
                this.$emit('adminDeleted');
                this.$notify(`${userEmail} has been removed`);
              })
              .catch(() => {
                this.$notify('Failed to delete user', { type: 'error' });
              })
              .finally(() => {
                loader.hide();
              });
            }
          },
        });
      },
    },
    watch: {
      admins(list) {
        this.mockGroups = list;
      },
    },
  };
</script>

<style scoped>
  .ccEmail {
    background-color: #0080ff !important;
  }
  .ccEmail:hover {
    background-color: #0080ef !important;
    color: #fff;
  }
  .suspended-bg {
    background-color: #ff4b4b32 !important;
  }

  .grp-admin-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  .email {
    font-weight: 300;
    font-size: 14px;
  }
  .status-label {
    padding: 0.25rem 0.5rem;
    border-radius: 8px;
    font-size: 0.7rem;
    font-weight: 400;
    text-transform: uppercase;
  }
  .status-label.active {
    background-color: #e5f9e7;
    color: #2e7d32;
  }
  .status-label.suspended {
    background-color: #ffe5e5;
    color: #d32f2f;
  }

  .activate-dialog .vc-title {
    color: #2e7d32 !important; /* green */
  }

  .activate-dialog .vc-btn.left {
    background-color: #ccc; /* optional: gray for 'No' */
    color: #333;
  }
  @media (max-width: 430px) {
    .grp-admin-info {
      gap: 0.5rem;
    }
  }
</style>
